import { createContext, ReactNode, useState } from 'react';

export interface MobileNavigationContextType {
  isOpen: boolean;
  setIsOpen: (arg: boolean) => void;
}

export const MobileNavigationContext =
  createContext<MobileNavigationContextType>({
    isOpen: false,
    setIsOpen: () => {},
  });

const MobileNavigationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <MobileNavigationContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </MobileNavigationContext.Provider>
  );
};

export default MobileNavigationProvider;
